module.exports = __webpack_public_path__ + "img/oval_selected.2fc99063.svg";